module.exports = __webpack_public_path__ + "78ffc5ca39d2bdd640976df81659dd42.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-27.png
// module id = 1505
// module chunks = 0